<button
  type="button"
  class="flex items-center justify-center rounded-full border-2 border-primary-500 bg-primary-500 p-2 text-neutral-0 hover:border-primary-600 hover:bg-primary-600 disabled:cursor-wait"
  [disabled]="opening()"
  [matTooltip]="'packageCoverage.action.showCoverage' | translate"
  (click)="openCoverage()"
>
  @if (opening()) {
    <mat-spinner
      class="m-0.5 [--mat-progress-spinner-active-indicator-color:var(--color-neutral-0)]"
      diameter="20"
    ></mat-spinner>
  } @else {
    <mat-icon>verified_user</mat-icon>
  }
</button>
